export default "__VITE_ASSET__ryd6902K__"